const SESSION_KEY = 'token'
// 本地存储 sessionStorage
const sessionStorage = window.sessionStorage
export const session = {
  getItem: function (key) {
    return sessionStorage.getItem(key)
  },
  setItem: function (key, value) {
    sessionStorage.setItem(key, value)
  },
  remove: function (key) {
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key)
    }
  },
  clear: function () {
    sessionStorage.clear()
  },
  parseJSON: function () {
    return sessionStorage.getItem(SESSION_KEY) === 'undefined' ? null : JSON.parse(sessionStorage.getItem(SESSION_KEY))
  },
  setObject: function (object) {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(object))
  },
  get: function (key) {
    let initParams = JSON.parse(sessionStorage.getItem(SESSION_KEY))
    return initParams[key] || ''
  },
  set: function (key, value) {
    let initParams = JSON.parse(sessionStorage.getItem(SESSION_KEY))
    initParams[key] = value
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(initParams))
  },
  cut: function (key) {
    let initParams = JSON.parse(sessionStorage.getItem(SESSION_KEY))
    delete initParams[key]
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(initParams))
  }
}

// 本地存储 localStorage
const localStorage = window.localStorage
export const local = {
  getItem: function (key) {
    return localStorage.getItem(key)
  },
  setItem: function (key, value) {
    localStorage.setItem(key, value)
  },
  removeItem: function (key) {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key)
    }
  },
  clear: function () {
    localStorage.clear()
  }
}

// cookie
export const cookie = {
  setCookie :function (name, value, n) {
    if (n) {
      let oDate = new Date()
      oDate.setDate(oDate.getDate() + n)
      document.cookie = name + "=" + value + ";expires=" + oDate + ";path=/"
    } else {
      document.cookie = name + "=" + value + ";path=/"
    }
  },
  getCookie: function(name) {
    let str = document.cookie
    let arr = str.split("; ")
    for (let i = 0; i < arr.length; i++) {
      let newArr = arr[i].split("=")
      if (newArr[0] == name) {
        return newArr[1]
      }
    }
  },
  removeCookie: function(name) {
    cookie.setCookie(name, 1, -1)
  },
    // 增强版删除方法，可以指定路径
    removeCookieEx: function(name) {
      const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = name + "=;expires=" + expires + ";path=/";
      
      // 为了确保删除，尝试多种方式
      document.cookie = name + "=;expires=" + expires + ";path=/;domain=" + window.location.hostname;
      document.cookie = name + "=;expires=" + expires + ";path=/;SameSite=Lax";
    }
}

